import { css } from 'styled-components';
import {
  getTypography,
  TypographyName,
  ThemedFunctor,
  getSpacing,
  SpacingName,
} from '@doveit/lego';

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H2)}
  color: ${theme.palettes.brand.primary};
`;

export const header: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  ${getSpacing.paddingBottom(theme, SpacingName.MEDIUM)}
  max-width: 50rem;
`;

export const breadcrumb: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
`;
